import { render, staticRenderFns } from "./PurchaseProcedure.vue?vue&type=template&id=3bb4ec78&scoped=true&"
import script from "./PurchaseProcedure.vue?vue&type=script&lang=js&"
export * from "./PurchaseProcedure.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseProcedure.vue?vue&type=style&index=0&id=3bb4ec78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb4ec78",
  null
  
)

export default component.exports